import { getRoot } from 'mobx-state-tree';
const IDLE_MANAGEMENT_FEATURE_KEY = 'idleTimeManagement';
const Views = self => ({
    get isEnabled() {
        var _a;
        const isEligible = (_a = getRoot(self).user) === null || _a === void 0 ? void 0 : _a.features.includes(IDLE_MANAGEMENT_FEATURE_KEY);
        return isEligible && !!self.time;
    },
});
export default Views;
